module.exports = __webpack_public_path__ + "img/pingan_logo1.88b908d3.png";